import { Button } from '@mui/material';
import { cn } from 'cn';
import { type ForwardedRef, forwardRef } from 'react';

import { type UUID } from '~/types/common';

import { SearchInput } from '~/ui/molecules/SearchInput';

type P = {
  readonly editButtonTestId?: string;
  readonly hasChanges: boolean;
  readonly isDisabled: boolean;
  readonly isEditing: boolean;
  readonly onAdd: (itemId: UUID) => void;
  readonly onCancel: () => void;
  readonly onEdit: () => void;
  readonly onFocus: () => void;
  readonly onSave: () => void;
  readonly saveButtonTestId?: string;
  readonly searchString: string;
  readonly setSearchString: (value: string) => void;
} & ComponentStyling;

export const ListActions = forwardRef(
  (
    {
      className,
      editButtonTestId,
      hasChanges,
      isDisabled = false,
      isEditing,
      onCancel,
      onEdit,
      onFocus,
      onSave,
      saveButtonTestId,
      searchString,
      setSearchString,
      style,
    }: P,
    ref: ForwardedRef<HTMLInputElement>,
  ) => (
    <div
      className={cn(
        'flex w-full items-end gap-2 border-b border-tiga-border-lighter p-2',
        className,
      )}
      style={style}
    >
      <SearchInput
        ref={ref}
        debounceTime={800}
        value={searchString}
        onChange={setSearchString}
        onFocus={onFocus}
      />
      <div className="flex flex-initial gap-2">
        {isEditing ? (
          <div className="flex items-center space-x-2">
            <Button
              className="h-10"
              data-testid={saveButtonTestId}
              disabled={!hasChanges}
              variant="contained"
              onClick={onSave}
            >
              Speichern
            </Button>
            <Button
              className="h-10"
              color="primary"
              variant="text"
              onClick={onCancel}
            >
              Abbrechen
            </Button>
          </div>
        ) : isDisabled ? null : (
          <Button
            className="h-10"
            data-testid={editButtonTestId}
            size="medium"
            variant="outlined"
            onMouseDown={onEdit}
          >
            Bearbeiten
          </Button>
        )}
      </div>
    </div>
  ),
);
